import { render, staticRenderFns } from "./PagePart3.vue?vue&type=template&id=c240159a&scoped=true"
import script from "./PagePart3.vue?vue&type=script&lang=js"
export * from "./PagePart3.vue?vue&type=script&lang=js"
import style0 from "./PagePart3.vue?vue&type=style&index=0&id=c240159a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c240159a",
  null
  
)

export default component.exports